import { Box, Button, Typography } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import { PromotionBanner } from "@outschool/ui-components-website";
import {
  Container,
  Loading,
  PageWidthSection,
} from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import { isOrganizationAdminWhoCanEnroll } from "../../lib/Users";
// @ts-ignore
import ClassRequestForm from "../ClassRequestForm";
import { LowEsaCreditBanner } from "../esaMemberships/LowEsaCreditBanner";
import StickyHeader from "../parentDashboard/tabs/StickyHeader";
import AvailableSeatsFromWaitlistBanner from "./AvailableSeatsFromWaitlistBanner";
import EnrolledLearnerSuccessBanner from "./EnrolledLearnerSuccessBanner";
import FeaturedClasses from "./FeaturedClasses";
import { AddLearnerBanner } from "./learnerCards/AddLearnerBanner";
import { LoggedInHomeMyClassesList } from "./LoggedInHomeMyClassesList";
import { WalletCTABanner } from "./walletCTA/WalletCTABanner";

export default function ParentDashboardDesktop({ children }: $TSFixMe) {
  const { t } = useTranslation("client\\components\\loggedInHome\\Dashboard");
  const { currentUser, currentUserIsLoading } = useSession();
  const isMobile = useIsMobile();

  const child = currentUserIsLoading ? (
    <Loading />
  ) : isOrganizationAdminWhoCanEnroll(currentUser) ? (
    <Trans t={t}>
      <Box
        sx={(theme: $TSFixMe) => ({
          maxWidth: "750px",
          position: "relative",
          width: "100%",
          marginX: "auto",
          boxSizing: "border-box",
          paddingX: "1em",

          [theme.breakpoints.up("md")]: {
            paddingX: "2em",
          },

          paddingY: "2em",
          textAlign: "center",
        })}
      >
        You can always reach us by email at{" "}
        <a href="mailto:support@outschool.com">support@outschool.com</a>
      </Box>
    </Trans>
  ) : (
    <>
      <Container size="medium">
        <FeaturedClasses />
        <Box sx={{ marginBottom: "4.8rem" }}>
          <PromotionBanner />
        </Box>
      </Container>
      <RequestAClass />
    </>
  );

  return (
    <>
      <StickyHeader />
      <AddLearnerBanner />
      <EnrolledLearnerSuccessBanner />
      <AvailableSeatsFromWaitlistBanner />
      {currentUser?.hasEsaMembership && <LowEsaCreditBanner />}

      {
        // Fix for error thrown on callback from apple sign up P. Albert Jun 20 2022
        !currentUser ? null : (
          <Container size="medium">
            <LoggedInHomeMyClassesList />
          </Container>
        )
      }

      {children && (
        <Box
          sx={{
            marginY: isMobile ? "1em" : "2em",
          }}
        >
          {children}
        </Box>
      )}

      <WalletCTABanner />

      {child}
    </>
  );
}

function RequestAClass() {
  const { t } = useTranslation("client\\components\\loggedInHome\\Dashboard");
  const { isLoggedIn } = useSession();
  return (
    <PageWidthSection
      sx={{
        backgroundColor: "rgba(43, 167, 206, 0.1)",
        paddingBottom: "4em",
        marginBottom: "-2em",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <Typography
          variant="h3"
          align="center"
          sx={{
            marginBottom: "0.5em",
          }}
        >
          {t("Interested in something in particular?")}
        </Typography>
        <ClassRequestForm
          isLoggedIn={isLoggedIn}
          renderButton={(open: $TSFixMe) => (
            <Button variant="contained" onClick={open}>
              {t("Request a Topic")}
            </Button>
          )}
        />
      </Box>
    </PageWidthSection>
  );
}
